const formatMonth = (value) => {
    if (!value) return "-";

    const [year, month, day] = value.split("-").map(Number);

    const date = new Date(year, month - 1, day);

    return date.toLocaleDateString("en-AU", {
        month: "short",
        year: "2-digit"
    });
};

export const applicationColumns = [
    {
        key: "Group",
        label: "Month",
        render: formatMonth
    },
    {
        key: "Count",
        label: "Applications",
        align: "right",
    },
    {
        key: "Volume",
        label: "Loan Amount",
        align: "right",
        render: (value) =>
            Number(value).toLocaleString("en-AU", {
                style: "currency",
                currency: "AUD",
                maximumFractionDigits: 0
            })
    }
];

export const settlementColumns = [
    {
        key: "Group",
        label: "Month",
        render: formatMonth
    },
    {
        key: "Count",
        label: "Settlements",
        align: "right"
    },
    {
        key: "Volume",
        label: "Loan Amount",
        align: "right",
        render: (value) =>
            Number(value).toLocaleString("en-AU", {
                style: "currency",
                currency: "AUD",
                maximumFractionDigits: 0
            })
    }
];

export const productColumns = [
    {
        key: "Group",
        label: "Product",
    },
    {
        key: "Count",
        label: "Applications",
        align: "right",
    },
    {
        key: "Volume",
        label: "Loan Amount",
        align: "right",
        render: (value) =>
            Number(value).toLocaleString("en-AU", {
                style: "currency",
                currency: "AUD",
                maximumFractionDigits: 0
            })
    },
    {
        key: "share",
        label: "Share",
        align: "right",
        type: "bar"
    }
];

export const typeColumns = [
    {
        key: "Group",
        label: "Type",
    },
    {
        key: "Count",
        label: "Applications",
        align: "right",
    },
    {
        key: "Volume",
        label: "Loan Amount",
        align: "right",
        render: (value) =>
            Number(value).toLocaleString("en-AU", {
                style: "currency",
                currency: "AUD",
                maximumFractionDigits: 0
            })
    },
    {
        key: "share",
        label: "Share",
        align: "right",
        type: "bar"
    }
];

export const collateralColumns = [
    {
        key: "Group",
        label: "Collateral State",
    },
    {
        key: "Count",
        label: "Applications",
        align: "right",
    },
    {
        key: "Volume",
        label: "Loan Amount",
        align: "right",
        render: (value) =>
            Number(value).toLocaleString("en-AU", {
                style: "currency",
                currency: "AUD",
                maximumFractionDigits: 0
            })
    },
    {
        key: "share",
        label: "Share",
        align: "right",
        type: "bar"
    }
];

export const brokerColumns = [
    {
        key: "Group",
        label: "Broker State",
    },
    {
        key: "Count",
        label: "Applications",
        align: "right",
    },
    {
        key: "Volume",
        label: "Loan Amount",
        align: "right",
        render: (value) =>
            Number(value).toLocaleString("en-AU", {
                style: "currency",
                currency: "AUD",
                maximumFractionDigits: 0
            })
    },
    {
        key: "share",
        label: "Share",
        align: "right",
        type: "bar"
    }
];

export const loanBookColumns = [
    {
        key: "Group",
        label: "Month",
        render: formatMonth
    },
    {
        key: "Volume",
        label: "Current Balance",
        align: "right",
        render: (value) =>
            Number(value).toLocaleString("en-AU", {
                style: "currency",
                currency: "AUD",
                maximumFractionDigits: 0
            })
    }
];